module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/cat-52296175a6c30a688e78d30b73813661.png";